import React, { useId, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RuleIcon from "@mui/icons-material/Rule";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import InventoryIcon from "@mui/icons-material/Inventory";

const SCORING = [
  {
    group: "Entrar al campus",
    icon: <VpnKeyIcon />,
    rules: [
      { label: "Entrar 3 días seguidos", points: 1 },
      { label: "Entrar 5 días seguidos", points: 2 },
      { label: "Entrar 10 días seguidos", points: 3 },
    ],
  },
  {
    group: "Visionar videoclases",
    icon: <OndemandVideoIcon />,
    rules: [{ label: "Videoclase completa", points: 2 }],
  },
  {
    group: "Hacer test",
    icon: <ContentPasteSearchIcon />,
    rules: [
      {
        label: "Nota menor a 5",
        points: 0,
        note: "¡Lo siento, no has obtenido ningún punto para el Ranking global!",
      },
      {
        label: "Nota entre 5 y 7,49",
        points: 3,
        note: "¡Enhorabuena, has obtenido 3 puntos en el Ranking global!",
      },
      {
        label: "Nota de 7,5 o más",
        points: 5,
        note: "¡Enhorabuena, has obtenido 5 puntos en el Ranking global!",
      },
      { label: "Puntualidad: hacer el test en su semana", points: 2 },
      { label: "BONUS «PLENO»: completar el 100% del mes", points: 10, bonus: true },
    ],
  },
  {
    group: "Abrir recursos",
    icon: <InventoryIcon />,
    rules: [{ label: "Abrir un recurso", points: 1 }],
  },
];


const PointsBadge = ({ points, bonus }) => (
  <span
    className={
      "gr-points-badge" +
      (points === 0 ? " is-zero" : "") +
      (bonus ? " is-bonus" : "")
    }
  >
    {points === 0 ? "0 pts" : `+${points} ${points === 1 ? "pt" : "pts"}`}
  </span>
);


const ScoringTable = () => (
  <div className="gr-card gr-scoring">
    <div className="gr-card-head">
      <span className="gr-trophy text-md-primary-container flex items-center" role="img" aria-label="puntos">
        <RuleIcon sx={{ fontSize: 32 }} />
      </span>
      <div>
        <h3>¿Cómo ganan puntos los alumnos?</h3>
        <p>Sistema de puntuación del Ranking global</p>
      </div>
    </div>

    {SCORING.map((section) => (
      <div key={section.group} className="gr-scoring-group">
        <p className="gr-group-title">
          <span className="gr-group-icon flex items-center" aria-hidden="true" style={{ color: '#ecb236' }}>
            {section.icon}
          </span>
          {section.group}
        </p>
        <ul className="gr-rule-list">
          {section.rules.map((rule) => (
            <li key={rule.label} className="gr-rule">
              <div className="gr-rule-main">
                <span className="gr-rule-label">{rule.label}</span>
                <PointsBadge points={rule.points} bonus={rule.bonus} />
              </div>
              {rule.note && <span className="gr-rule-note">{rule.note}</span>}
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
);


export const ScoringRules = () => {
  const [isOpen, setIsOpen] = useState(false);
  const id = useId();
  const triggerId = `${id}-trigger`;
  const panelId = `${id}-panel`;

  return (
    <div className="gr-scoring-disclosure">
      <h3 className="gr-scoring-heading">
        <button
          type="button"
          id={triggerId}
          className="gr-scoring-trigger"
          aria-expanded={isOpen}
          aria-controls={panelId}
          onClick={() => setIsOpen((open) => !open)}
        >
          <InfoOutlinedIcon aria-hidden="true" />
          <span>Cómo ganar puntos</span>
          <ExpandMoreIcon aria-hidden="true" className="gr-scoring-chevron" />
        </button>
      </h3>
      <div id={panelId} role="region" aria-labelledby={triggerId} hidden={!isOpen}>
        <ScoringTable />
      </div>
    </div>
  );
};
